import React, { useState } from 'react';
import ModalBase from '../ModalBase';
import InputField from '../../InputField';
import CryptoAmountInput from '../../CryptoAmountInput';
import higherLogo from '../../../assets/imgs/ico-higher-titulo.svg';
import criptoService from  '../../../services/Cripto/criptoFoxbitService';
import { isBinance } from  '../../../utils/isBinance';

function CryptoTrade({ show, onClose, availableBalance, currentBalance, price, amount }) {
  const [tradeType, setTradeType] = useState('BUY');

  const [coin, setCoin] = useState('usdtbrl');
  const [network, setNetwork] = useState('trc20');
  const [address, setAddress] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [available, setAvailable] = useState(false);
  const [amountQuote, setAmountQuote] = useState(false);
  const [value, setValue] = useState('');
  const [amountFiat, setAmountFiat] = useState('');

  const handleClose = async () => {
    if (inputValue !== '' && inputValue !== value) {
      await quote(inputValue);
    }

    onClose({
      tradeType,
      coin,
      network,
      address,
      value,
      amountFiat,
    });
  };

  const handleBack = () => {
    onClose(null);
  };

  const quote = async (val) => {
    let data = {
      service: "2",
      body: {
        fromCurrency: "USDT",
        toCurrency: "BRL",
        side: "Compra",
        receiveAmount: val,
        spendAmount: "",
        email: sessionStorage.getItem('emailUser')
      }
    };

    try {
      let res = {};
      if(!isBinance()){
        res = await criptoService.createQuote(data);
      }
      else {
        data = {
          body: {
            base_currency: "USDT",
            quote_currency: "BRL",
            side: "buy",
            quantity: "1",
            email: sessionStorage.getItem('emailUser')
          }
        };
        res = await criptoService.createQuoteBnb(data);
      }
      setValue(val);
      setAmountFiat(Number(val) * Number(res.data.price));
      setAmountQuote(Number(res.data.quote_amount));
      setAvailable(true);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ModalBase show={show} onClose={handleClose}>
      <div style={styles.container}>
        <div style={styles.closeButtonContainer}>
          <button style={styles.closeButton} onClick={handleBack}>
            &times;
          </button>
        </div>
        <div style={styles.leftPanel}>
          <h2 style={styles.title}>
            <img src={higherLogo} alt="Logo Higher" style={styles.logo} />
            Trade
          </h2>

          <InputField label="Coin" readOnly={true} value={coin.toUpperCase()} onChange={e => setCoin(e.target.value)} />
          <label>
            <span style={{fontSize: "11px", color: "#888"}}>Network</span><br/>
            <select value={network} onChange={e => setNetwork(e.target.value)}>
              <option value="TRC20">TRC20</option>
              <option value="ERC20">ERC20</option>
              <option value="BEP20">BEP20</option>
              <option value="MATIC">POLYGON</option>
            </select>
          </label>
          <InputField label="Address" value={address} onChange={e => setAddress(e.target.value)} />

          <div style={styles.balanceInfo}>
            Available balance <span style={styles.balanceValue}>{Number(availableBalance.replace(",", ".")).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span>
          </div>
        </div>

        <div style={styles.rightPanel}>
          <div style={styles.switchContainer}>
            <button
              style={{
                ...styles.switchButton,
                backgroundColor: tradeType === 'BUY' ? '#ddd' : '#ddd',
              }}
              onClick={() => setTradeType('BUY')}
            >
              Buy
            </button>
          </div>

          <CryptoAmountInput
            label="Value"
            value={inputValue}
            onChange={(e) => setInputValue(e)}
            containerStyle={{ marginTop: 20 }}
          />

          <button
            style={{
              marginTop: 10,
              padding: "8px 16px",
              backgroundColor: "#1c787e",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
            onClick={() => quote(inputValue)}
          >
            Cotar
          </button>

          <div style={styles.balanceInfo}>
            Price <span style={styles.price}>BRL {amountFiat !== '' ? amountFiat : price}</span>
          </div>
          <div style={{ ...styles.balanceInfo, color: '#888' }}>
            Amount <span style={styles.amount}>USDT {value !== '' ? value : "1.000000"}</span>
          </div>

          <button style={{
          ...styles.button,
          backgroundColor: available ? '#627EEA': '#bbb'}} onClick={handleClose}>
            Comprar
          </button>
        </div>
      </div>
    </ModalBase>
  );
}

export default CryptoTrade;

const styles = {
  closeButtonContainer: {
    position: 'absolute',
    top: '0px',
    right: '10px',
    zIndex: 10,
  },
  closeButton: {
    fontSize: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#888',
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '100%',
    minWidth: '650px',
    overflow: 'hidden',
    fontFamily: 'sans-serif',
  },
  leftPanel: {
    width: '50%',
    padding: '30px',
    borderRight: '1px solid #eee',
    boxSizing: 'border-box',
  },
  rightPanel: {
    width: '48%',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: '24px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '35px',
    marginRight: '5px',
  },
  balanceInfo: {
    marginBottom: '10px',
    color: '#555',
    fontSize: '14px',
  },
  balanceValue: {
    float: 'right',
  },
  price: {
    float: 'right',
  },
  amount: {
    float: 'right',
  },
  button: {
    padding: '15px',
    backgroundColor: '#1c787e',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 'auto',
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  switchButton: {
    flex: 1,
    padding: '10px',
    margin: '0 5px',
    borderRadius: '5px',
    border: 'none',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
};
